export default "__VITE_ASSET__9448cf6b__"